import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface FavoriteOrdering {
  favoriteId: string;
  favoriteIdToMoveAfter: string;
}

export interface OrderFavoritesParams {
  orderings: FavoriteOrdering[];
}

export class OrderFavoritesRequest extends Request<OrderFavoritesParams, IResult> {
  constructor(params: OrderFavoritesParams) {
    super('orderFavorites', params);
  }
}
